var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconReset = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L4 11L8 7L6.5 5.5L5 7C5 6.4774 5.08017 5.97352 5.2289 5.5C5.86603 3.47145 7.76118 2 10 2C10.8664 2 11.6814 2.22038 12.3919 2.60814L13.8482 1.15176C12.7441 0.423723 11.4215 0 10 0C6.64888 0 3.84776 2.35482 3.16109 5.5C3.05559 5.98323 3 6.48513 3 7L1.5 5.5L0 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15173 14.8482L7.60811 13.3919C8.3186 13.7796 9.13355 14 9.99998 14C12.2388 14 14.1339 12.5286 14.7711 10.5C14.9198 10.0265 15 9.5226 15 9L13.5 10.5L12 9L16 5L20 9L18.5 10.5L17 9C17 9.51487 16.9444 10.0168 16.8389 10.5C16.1522 13.6452 13.3511 16 9.99998 16C8.57846 16 7.25591 15.5763 6.15173 14.8482Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReset, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-reset.670e432f.svg";
export { ForwardRef as ReactComponent };